import { observable } from 'mobx'
import { User } from '@/features/iam/users/User'
import { Workspace } from '@/features/iam/workspaces/Workspace'
import { Model, type ModelProps } from '@/infra/model'
import type { TransactionSourceType } from '@/features/payouts/transaction-source-type'
import type { TransactionType } from '@/features/payouts/transaction-type'
import type { UserTransactionReason } from '@/features/payouts/user-transaction-reason'
import { Id } from '@/infra/id'
import { unixEpoch } from '@/utils/date-util'
import type { TransactionFlag } from '@/features/payouts/transaction-flag'
import type { TransactionFailureReason } from '@/features/payouts/transaction-failure-reason'

export type PendingTransactionProps = ModelProps<PendingTransaction>

/**
 * A transaction waiting to be approved into a payout.
 */
export class PendingTransaction extends Model<PendingTransaction> {
  id = Id.none
  @observable accessor shortId = ''
  @observable accessor amount = 0
  @observable accessor createdAt = unixEpoch()
  @observable accessor transactedAt = unixEpoch()
  @observable accessor type: TransactionType = 'Payment'
  @observable accessor recipient = User.none
  @observable accessor workspace = Workspace.none
  @observable accessor source: TransactionSourceType = 'Unknown'

  @observable accessor reason: UserTransactionReason | null = 'Unknown'
  @observable accessor memo: string | null = null

  @observable accessor jobId = Id.none

  @observable accessor flags: TransactionFlag[] = []

  @observable accessor iteration = 1

  @observable accessor lastFailureReason: TransactionFailureReason | null = null
  @observable accessor lastFailureDescription: string | null = null
}
